import Slider_1 from './../img/casa/apto_2/01.jpg'
import Slider_2 from './../img/casa/apto_2/02.jpg'
import Slider_3 from './../img/casa/apto_2/03.jpg'
import Slider_4 from './../img/casa/apto_2/04.jpg'
import Slider_5 from './../img/casa/apto_2/05.jpg'
import Slider_6 from './../img/casa/apto_2/06.jpg'

import Carousel from 'react-bootstrap/Carousel';

export default function SliderCasaSM2() {
    return (
        <>


            <Carousel interval={3500}>
                    <Carousel.Item>
                        <img className='d-block w-100' src={Slider_1} alt='First slide' />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img className='d-block w-100' src={Slider_2} alt='Third slide' />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img className='d-block w-100' src={Slider_3} alt='Third slide' />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img className='d-block w-100' src={Slider_4} alt='Third slide' />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img className='d-block w-100' src={Slider_5} alt='Third slide' />
                    </Carousel.Item>
                    <Carousel.Item>
                        <img className='d-block w-100' src={Slider_6} alt='Third slide' />
                    </Carousel.Item>
                </Carousel>
        </>
    )
}